// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".font-size-ng{font-size:10pt!important;color:#1c0152!important}", ""]);
// Exports
module.exports = exports;
